import { SvgLogoProps } from './Logo.types'
import React from 'react'

const OfficeOfTheYearLogo = ({ width = 136, height = 99, ...props }: SvgLogoProps) => {
    return (
        <svg
            {...props}
            width={width}
            height={height}
            viewBox='0 0 136 99'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            {/* eslint-disable-next-line max-len */}
            <path
                d='M74.1222 96.471C70.357 92.4634 64.1644 89.9429 59.0318 88.2411C59.4297 84.2217 57.7598 79.2236 52.7933 75.5993C51.5098 74.6928 50.1724 73.8653 48.7886 73.1211C49.0354 75.988 49.7163 78.4508 50.9123 80.3509C52.253 82.4946 56.4124 86.3524 58.2659 87.9905C55.146 86.9816 52.2127 86.1617 48.8733 85.1708C48.9022 84.0806 48.612 82.5645 48.2359 81.1411C47.8191 79.5755 47.3073 78.1237 46.9463 77.4745C45.9519 75.7786 44.6824 74.2599 43.1897 72.9805C42.1658 72.0917 41.0966 71.2565 39.9864 70.4782C39.6793 74.9058 40.5692 79.1294 48.0467 84.9246C44.9195 83.9886 41.892 83.0281 38.835 81.842C38.9084 80.7095 38.6208 74.5829 34.9138 69.6215C34.0078 68.4216 33.1792 67.5088 32.6479 66.9244C30.7485 72.6529 33.6339 77.7921 37.992 81.5092C34.9958 80.3361 32.1089 78.9012 29.3648 77.221C30.0365 73.9994 29.7769 67.8267 26.864 61.9929C23.154 67.3823 25.9338 73.6808 28.6009 76.7352C25.932 75.0237 23.4894 72.9826 21.3308 70.6603C21.2994 70.6265 21.2689 70.592 21.2377 70.5581C22.2122 68.4223 24.4226 61.2361 22.4237 55.2009C18.6362 58.882 18.3157 64.2257 20.1474 68.8224C20.2879 69.1869 20.4514 69.5421 20.6369 69.886L20.6405 69.8926C18.5237 67.4627 16.7297 64.7696 15.3028 61.8801C18.8218 57.2869 20.029 52.037 19.2694 47.0218C14.5773 50.073 13.7661 56.6807 14.9411 61.1334C13.542 58.2033 12.4027 55.1561 11.5363 52.0269C15.8726 47.7603 17.7727 42.7674 17.7791 38.3135C14.1393 39.7987 12.1648 43.4394 11.5123 47.2413C11.2569 48.5892 11.2031 49.9677 11.3527 51.3314C10.5167 48.1551 9.98611 44.9061 9.76803 41.6289C10.783 40.7705 11.7541 39.8617 12.6777 38.9058C13.5325 38.0441 17.2095 34.9147 18.0249 29.2707C14.3001 30.0818 11.8494 33.3186 10.5739 36.8492C10.0612 38.2654 9.78197 39.7555 9.74701 41.2612C9.65842 39.8059 9.62283 38.3821 9.65263 37.0036C9.84196 29.7883 11.3279 22.6658 14.0394 15.9766C14.1596 15.6678 14.2649 15.4167 14.3455 15.2221C14.7526 14.7852 15.399 13.93 16.1025 12.9912C17.0364 11.7343 18.069 10.3291 18.6353 9.41749C21.0434 5.50872 21.8267 2.50305 22.5102 0.292969C19.8957 2.19388 17.7562 4.12504 16.075 7.65965C15.4481 9.05961 14.9471 10.5126 14.5778 12.0014C14.3036 13.0064 14.1165 14.0333 14.0187 15.0705C13.9328 15.2747 13.8157 15.5458 13.681 15.8876C13.0306 17.4748 12.2608 19.6067 11.6417 21.6772C11.7299 21.0662 11.9511 19.2374 12.24 17.1821C12.3968 16.0484 12.5728 14.8471 12.7081 13.7387C12.8449 12.7864 12.9164 11.8258 12.9222 10.8637C12.8646 8.74987 12.381 6.36467 11.6603 3.67628C9.99469 6.80567 8.69339 10.2201 9.12392 14.0428C9.34925 16.1575 10.1565 20.2834 11.6027 21.8085C10.6255 25.0638 9.92837 28.3966 9.51903 31.7707C8.80154 21.4933 9.56661 21.115 6.19076 14.1075C2.99069 23.7864 7.66348 30.9673 9.46228 32.2657C9.09022 35.5586 9.01891 38.8785 9.24923 42.1844C6.45596 32.6932 7.36556 32.0716 2.39636 25.4528C1.04678 35.2529 6.13205 41.5566 9.31143 42.9587C9.58641 46.19 10.158 49.3891 11.019 52.5156C6.22634 43.9072 7.04978 43.0605 0.642578 37.5387C1.2804 48.6311 8.94612 52.996 11.2936 53.4773C12.1947 56.5356 13.3562 59.511 14.7654 62.371C14.1196 61.6316 13.2147 60.5787 12.2587 59.4253C12.0496 59.1811 11.8452 58.9295 11.6411 58.6757C8.40682 54.7402 7.65972 53.2493 1.27953 49.9335C4.22048 59.7931 11.5154 63.4713 15.3025 63.4181C16.7727 66.202 18.5852 68.7912 20.6978 71.1254C20.6203 71.078 20.5421 71.0303 20.4597 70.9799C20.0481 70.727 19.5899 70.4231 19.0834 70.0984C18.5948 69.7592 18.046 69.4069 17.5118 69.0135C12.3979 65.4453 12.2142 63.9768 4.37553 62.0031C7.94104 68.5256 13.329 73.0511 20.6377 72.3155C20.8278 72.2949 21.0086 72.2678 21.1785 72.2337C21.3331 72.2032 21.4859 72.1639 21.6362 72.1161C23.8138 74.3278 26.2436 76.2759 28.8759 77.9205C28.3495 77.7814 26.7397 77.331 25.2499 76.8432C18.8825 74.7459 18.5462 73.7218 10.1896 73.6617C18.349 82.5984 27.3807 80.5592 30.1524 78.6979C32.7822 80.2268 35.5269 81.5491 38.3615 82.6529C27.7836 82.0163 27.4196 80.9972 19.3382 83.6904C30.0829 89.9638 38.6142 84.4794 39.8755 83.2387C42.6764 84.2925 45.4935 85.1899 48.356 86.0622C46.2216 86.1516 39.2875 86.4711 37.228 87.0847C35.0095 87.7497 32.7209 89.036 30.2832 90.752C32.0477 91.2976 33.8636 91.6606 35.7023 91.8353C42.1948 92.3704 48.7963 87.9889 50.0216 86.567C52.5664 87.3344 55.632 88.2359 58.3774 89.1592C47.3832 89.5044 44.8661 91.7068 41.2971 95.4443C42.9955 95.7038 44.7132 95.8155 46.4309 95.7781C51.9154 95.5765 58.8515 91.1362 60.1211 89.7634C68.5938 92.7997 71.9189 95.6503 74.4275 98.6343C74.3661 97.908 74.2642 97.1858 74.1222 96.471Z'
                fill='url(#paint0_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M10.1055 31.0703C16.9149 27.1452 19.0635 23.3071 19.9345 20.1626C14.8119 20.4904 10.9795 25.9576 10.1055 31.0703Z'
                fill='url(#paint1_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M16.8273 13.8325C15.9903 14.564 15.2454 15.3947 14.6089 16.3061C13.6759 17.6759 12.9336 19.1663 12.4026 20.7363C12.8671 20.5167 18.3016 17.734 19.4466 16.7155C21.0497 15.2813 22.7801 12.6919 23.3447 11.2831C20.8549 11.0828 18.712 12.1628 16.8273 13.8325Z'
                fill='url(#paint2_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M61.6267 96.4441C65.409 92.4526 71.6122 89.9587 76.7522 88.2788C76.3716 84.2577 78.0627 79.2668 83.0446 75.6637C84.3319 74.7628 85.6728 73.941 87.0598 73.2027C86.8008 76.0686 86.1093 78.5282 84.9053 80.4234C83.5554 82.5613 79.3796 86.4014 77.5192 88.0315C80.6434 87.0359 83.58 86.2286 86.9236 85.2519C86.8994 84.1617 87.1961 82.6468 87.5784 81.225C88.0017 79.6612 88.5198 78.2116 88.8835 77.5639C89.8851 75.8723 91.1612 74.359 92.6593 73.086C93.6869 72.2016 94.7596 71.3709 95.8731 70.5974C96.1613 75.0263 95.2533 79.246 87.7512 85.0093C90.8824 84.0866 93.914 83.1389 96.9761 81.966C96.9075 80.8333 97.2211 74.7079 100.949 69.7624C101.86 68.5663 102.693 67.657 103.227 67.075C105.102 72.8116 102.194 77.9384 97.8204 81.6368C100.822 80.4766 103.715 79.054 106.466 77.3856C105.808 74.1611 106.094 67.9896 109.032 62.1682C112.719 67.5734 109.912 73.86 107.232 76.903C109.908 75.2029 112.359 73.1723 114.528 70.8592C114.559 70.8255 114.59 70.7911 114.621 70.7573C113.656 68.6174 111.476 61.4219 113.501 55.3952C117.273 59.0925 117.57 64.4376 115.719 69.0263C115.577 69.3902 115.412 69.7448 115.225 70.0878L115.222 70.0944C117.349 67.6735 119.154 64.9881 120.594 62.1047C117.094 57.4965 115.909 52.2415 116.69 47.2296C121.369 50.3007 122.153 56.9118 120.958 61.3595C122.37 58.4354 123.522 55.3931 124.402 52.2675C120.084 47.9825 118.205 42.9816 118.218 38.5276C121.851 40.0284 123.81 43.6774 124.447 47.4821C124.696 48.8311 124.744 50.2098 124.589 51.5729C125.438 48.4002 125.983 45.1535 126.215 41.8772C125.204 41.0145 124.236 40.1016 123.317 39.1417C122.466 38.2764 118.802 35.1313 118.011 29.4841C121.732 30.311 124.169 33.5581 125.429 37.0941C125.936 38.5125 126.209 40.0038 126.237 41.5097C126.332 40.0547 126.374 38.631 126.35 37.2525C126.191 30.0364 124.736 22.9077 122.053 16.207C121.934 15.8976 121.83 15.6461 121.75 15.4511C121.345 15.0126 120.702 14.1546 120.003 13.2128C119.074 11.9519 118.048 10.5423 117.485 9.62828C115.094 5.70915 114.324 2.70015 113.649 0.487305C116.256 2.39936 118.387 4.33964 120.053 7.88153C120.674 9.28416 121.169 10.7393 121.532 12.2296C121.802 13.2359 121.984 14.2635 122.078 15.3011C122.163 15.5056 122.279 15.7773 122.412 16.1195C123.055 17.7095 123.816 19.8447 124.426 21.9178C124.341 21.3065 124.127 19.4766 123.847 17.4202C123.695 16.2859 123.524 15.0838 123.394 13.9748C123.261 13.0219 123.194 12.0611 123.192 11.099C123.259 8.98544 123.752 6.6023 124.485 3.91701C126.137 7.05349 127.424 10.4734 126.977 14.2943C126.742 16.4082 125.917 20.5305 124.465 22.0494C125.428 25.3088 126.111 28.6446 126.506 32.0203C127.267 21.7461 126.504 21.3645 129.91 14.3715C133.068 24.064 128.365 31.2249 126.561 32.5154C126.919 35.8099 126.976 39.1301 126.731 42.4349C129.565 32.9558 128.658 32.3303 133.655 25.7327C134.963 35.5387 129.851 41.8205 126.666 43.2091C126.377 46.4392 125.792 49.6358 124.917 52.7587C129.747 44.1706 128.927 43.3206 135.358 37.8261C134.672 48.9157 126.988 53.248 124.638 53.7191C123.724 56.7736 122.55 59.7441 121.129 62.598C121.778 61.8614 122.687 60.8123 123.648 59.6629C123.858 59.4196 124.064 59.169 124.269 58.9159C127.52 54.9943 128.273 53.5065 134.668 50.2181C131.685 60.065 124.374 63.712 120.587 63.6427C119.105 66.4203 117.282 69.0018 115.159 71.3269C115.237 71.2799 115.315 71.2325 115.398 71.1824C115.81 70.9312 116.27 70.6293 116.778 70.3067C117.268 69.9697 117.818 69.6198 118.354 69.2286C123.483 65.6823 123.673 64.2145 131.52 62.2745C127.927 68.7817 122.52 73.284 115.214 72.5174C115.024 72.496 114.843 72.4681 114.674 72.4334C114.519 72.4022 114.367 72.3623 114.217 72.3139C112.03 74.5162 109.591 76.454 106.952 78.0873C107.479 77.9505 109.091 77.507 110.583 77.0255C116.959 74.9554 117.3 73.9328 125.656 73.9083C117.459 82.8101 108.436 80.7322 105.672 78.8593C103.036 80.3768 100.286 81.6872 97.4462 82.7788C108.027 82.1874 108.395 81.1699 116.465 83.8975C105.694 90.125 97.1857 84.6042 95.9297 83.3582C93.1244 84.4001 90.3035 85.2854 87.4373 86.1454C89.5713 86.2439 96.5039 86.5931 98.5609 87.2155C100.777 87.89 103.06 89.186 105.49 90.9124C103.723 91.4505 101.906 91.8058 100.066 91.9727C93.5714 92.48 86.9887 88.0704 85.7693 86.6432C83.2215 87.3998 80.152 88.2882 77.4026 89.1998C88.3952 89.5919 90.9029 91.8051 94.4559 95.5577C92.7564 95.8099 91.0383 95.9143 89.3208 95.8696C83.8372 95.6445 76.9202 91.1748 75.6564 89.7965C67.1708 92.7965 63.8335 95.6329 61.3123 98.6062C61.3767 97.8802 61.4817 97.1584 61.6267 96.4441Z'
                fill='url(#paint3_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M125.922 31.3173C119.129 27.3631 116.997 23.5159 116.14 20.3677C121.261 20.7172 125.07 26.2008 125.922 31.3173Z'
                fill='url(#paint4_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M119.274 14.0512C120.108 14.7863 120.849 15.6201 121.482 16.5342C122.409 17.908 123.145 19.4016 123.669 20.9738C123.206 20.7522 117.783 17.9463 116.642 16.923C115.045 15.482 113.326 12.8852 112.767 11.474C115.258 11.2844 117.396 12.3736 119.274 14.0512Z'
                fill='url(#paint5_linear_50_792)'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M42.3438 9.09473H45.2605C47.5174 9.09473 48.4327 10.074 48.4327 12.4373V13.3529C48.4327 15.1625 47.7514 16.1632 46.2612 16.4399V16.4613C47.7729 16.6955 48.4327 17.5898 48.4327 19.4633V22.231C48.4129 22.8275 48.4848 23.4235 48.6457 23.9982H48.156C48.0199 23.4192 47.9555 22.8257 47.9644 22.231V19.442C47.9644 17.4407 47.1128 16.6954 45.1113 16.6954H42.812V23.9982H42.3438V9.09473ZM45.0262 16.2484C47.0702 16.2484 47.9645 15.3968 47.9645 13.3954V12.48C47.9645 10.3721 47.198 9.54177 45.2393 9.54177H42.812V16.2484H45.0262Z'
                fill='white'
            />
            <path
                d='M50.7537 9.09473H56.3744V9.54177H51.2219V16.0141H55.544V16.4399H51.2219V23.5512H56.3744V23.9982H50.7537V9.09473Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M63.6776 20.3788H58.8661L58.0569 23.9982H57.6099L60.9312 9.03076H61.5701L64.9765 23.9982H64.508L63.6776 20.3788ZM63.5925 19.9316L61.2506 9.64826L58.9725 19.9316H63.5925Z'
                fill='white'
            />
            <path d='M66.7866 9.09473H67.2549V23.5512H72.2158V23.9982H66.7866V9.09473Z' fill='white' />
            <path d='M73.9619 9.09473H74.4304V23.9982H73.9619V9.09473Z' fill='white' />
            <path d='M79.1567 9.54177H76.176V9.09473H82.606V9.54177H79.625V23.9982H79.1567V9.54177Z' fill='white' />
            <path
                d='M84.3523 9.09473H85.0548L90.271 22.9123V9.09473H90.718V23.9982H90.1646L84.7993 9.75479V23.9982H84.3523V9.09473Z'
                fill='white'
            />
            <path
                d='M94.3168 5.24121H94.913L93.2737 7.66832H92.8052L94.3168 5.24121ZM93.1882 9.09476H93.6567V23.9982H93.1882V9.09476Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M26.8627 40.6931L26.2464 41.853V45.7501H24.2527V33.062H26.2464V38.5903L28.8564 33.062H30.8505L28.077 38.7172L30.8505 45.75H28.8021L26.8627 40.6931Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M35.7263 43.2667H33.4245L33.08 45.75H31.2312L33.2974 33.062H35.9983L38.0645 45.75H36.0708L35.7263 43.2667ZM35.4725 41.5448L34.5663 35.1464L33.6783 41.5448H35.4725Z'
                fill='white'
            />
            <path
                d='M39.0071 33.062H41.4721L43.4841 40.6566V33.062H45.2604V45.75H43.2484L40.7834 36.4879V45.7501H39.0071V33.062Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M46.6021 42.8136V35.9984C46.6021 34.0409 47.6168 32.8809 49.5384 32.8809C51.4599 32.8809 52.4747 34.0408 52.4747 35.9984V37.3398H50.5895V35.8715C50.5895 35.0378 50.1906 34.6934 49.5926 34.6934C48.9945 34.6934 48.5957 35.0377 48.5957 35.8715V42.9586C48.5957 43.7924 48.9945 44.1185 49.5926 44.1185C50.1906 44.1185 50.5895 43.7923 50.5895 42.9586V41.1098H52.4747V42.8136C52.4747 44.7711 51.4596 45.9312 49.5384 45.9312C47.6171 45.9312 46.6021 44.7712 46.6021 42.8136Z'
                fill='white'
            />
            <path
                d='M53.6531 33.062H59.0905V34.8746H55.6468V38.2279H58.3836V40.0404H55.6468V43.9374H59.0905V45.75H53.6531V33.062Z'
                fill='white'
            />
            <path d='M60.1602 33.062H62.1539V43.9374H65.4347V45.75H60.1602V33.062Z' fill='white' />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M70.4195 43.2669H68.1176L67.7731 45.7503H65.9243L67.9905 33.0622H70.6914L72.7576 45.7503H70.7639L70.4195 43.2669ZM69.7671 32.2828H68.2626L69.5315 29.8359H71.7066L69.7671 32.2828ZM70.1659 41.545L69.2594 35.1466L68.3714 41.545H70.1659Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M73.7002 33.0622H76.6547C78.721 33.0622 79.6092 34.0228 79.6092 35.9804V36.7597C79.6092 38.0648 79.1922 38.8985 78.3042 39.2611V39.2973C79.3011 39.6055 79.6274 40.548 79.6274 41.9799V44.2093C79.591 44.7325 79.6651 45.2575 79.8449 45.7501H77.8147C77.7062 45.4238 77.6337 45.2245 77.6337 44.1911V41.8711C77.6337 40.693 77.2892 40.3124 76.383 40.3124H75.6943V45.7501H73.7003L73.7002 33.0622ZM73.9904 29.8359H75.4947L76.4191 31.1952L77.3435 29.8359H78.848L77.3617 32.2828H75.4764L73.9904 29.8359ZM76.4191 38.4999C77.1624 38.4999 77.6155 38.1736 77.6155 37.1586V36.1799C77.6155 35.2735 77.3074 34.8747 76.6004 34.8747H75.6942V38.4999H76.4191Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M83.9053 33.062H86.8598C88.926 33.062 89.8143 34.0226 89.8143 35.9802V36.7595C89.8143 38.0646 89.3973 38.8983 88.5093 39.2609V39.2972C89.5062 39.6053 89.8325 40.5478 89.8325 41.9798V44.2091C89.7961 44.7323 89.8702 45.2573 90.05 45.7499H88.0198C87.9112 45.4236 87.8387 45.2244 87.8387 44.191V41.8709C87.8387 40.6928 87.4942 40.3122 86.5881 40.3122H85.8994V45.7499H83.9054L83.9053 33.062ZM86.6242 38.4998C87.3675 38.4998 87.8206 38.1734 87.8206 37.1584V36.1797C87.8206 35.2734 87.5124 34.8746 86.8055 34.8746H85.8993V38.4998H86.6242Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M91.0652 42.7411V36.0709C91.0652 34.0409 92.1345 32.8809 94.0922 32.8809C96.0498 32.8809 97.1192 34.0408 97.1192 36.0709V42.7411C97.1192 44.7711 96.0498 45.9312 94.0922 45.9312C92.1345 45.9312 91.0652 44.7712 91.0652 42.7411ZM95.1255 42.8681V35.9441C95.1255 35.0378 94.7266 34.6934 94.0922 34.6934C93.4577 34.6934 93.0589 35.0377 93.0589 35.9441V42.8681C93.0589 43.7742 93.4577 44.1186 94.0922 44.1186C94.7266 44.1186 95.1255 43.7742 95.1255 42.8681V42.8681Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M101.27 40.1672L100.455 41.7622V45.75H98.4607V33.062H100.455V38.5178L102.956 33.062H104.986L102.612 37.7203L105.022 45.75H102.938L101.27 40.1672Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M105.856 42.7411V33.062H107.85V42.8862C107.85 43.7925 108.231 44.1187 108.865 44.1187C109.499 44.1187 109.88 43.7925 109.88 42.8862V33.062H111.801V42.7411C111.801 44.7711 110.787 45.9311 108.829 45.9311C106.871 45.9311 105.856 44.7712 105.856 42.7411Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M47.2637 54.814H47.9161L50.7617 66.7588L53.5895 54.814H54.2418V67.5019H53.8433V55.3217L50.943 67.5019H50.5442L47.6443 55.3217V67.5019H47.2637L47.2637 54.814Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M56.218 64.6746V57.6419C56.218 55.6661 57.1788 54.6328 58.9187 54.6328C60.6586 54.6328 61.6194 55.6661 61.6194 57.6419V64.6746C61.6194 66.6501 60.6589 67.6834 58.9187 67.6834C57.1785 67.6834 56.218 66.6501 56.218 64.6746ZM61.2209 64.6925V57.6238C61.2209 55.8836 60.4232 55.0135 58.9187 55.0135C57.4142 55.0135 56.6168 55.8836 56.6168 57.6238V64.6926C56.6168 66.4328 57.4144 67.3028 58.9187 67.3028C60.423 67.3028 61.2209 66.4327 61.2209 64.6925Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M63.5955 54.814H66.0787C68 54.814 68.7794 55.6477 68.7794 57.6596V58.4391C68.7794 59.9797 68.1992 60.8316 66.9306 61.0673V61.0854C68.2175 61.2847 68.7794 62.0462 68.7794 63.6411V65.9973C68.7624 66.5051 68.8235 67.0126 68.9604 67.5019H68.5437C68.4277 67.009 68.3729 66.5036 68.3806 65.9973V63.6229C68.3806 61.9191 67.6554 61.2847 65.9516 61.2847H63.9943V67.5019H63.5955L63.5955 54.814ZM65.8792 60.9041C67.6194 60.9041 68.3806 60.1792 68.3806 58.4754V57.696C68.3806 55.9015 67.728 55.1946 66.0605 55.1946H63.9943V60.904L65.8792 60.9041Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M75.4316 64.4207H71.3352L70.6466 67.502H70.2659L73.0933 54.7598H73.6371L76.5373 67.502H76.1385L75.4316 64.4207ZM75.3591 64.0401L73.3654 55.2854L71.4259 64.0401H75.3591Z'
                fill='white'
            />
            <path
                d='M76.6646 54.814H77.0634L79.8183 67.0488L82.519 54.814H82.8996L80.0901 67.5561H79.5463L76.6646 54.814Z'
                fill='white'
            />
            {/* eslint-disable-next-line max-len */}
            <path
                d='M88.1927 64.4207H84.0963L83.4077 67.502H83.0271L85.8546 54.7598H86.3983L89.2986 67.502H88.8997L88.1927 64.4207ZM88.1202 64.0401L86.1264 55.2854L84.187 64.0401H88.1202Z'
                fill='white'
            />
            <defs>
                <linearGradient
                    id='paint0_linear_50_792'
                    x1='37.7023'
                    y1='-10.0108'
                    x2='37.4441'
                    y2='112.945'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
                <linearGradient
                    id='paint1_linear_50_792'
                    x1='15.0967'
                    y1='-10.0581'
                    x2='14.8385'
                    y2='112.897'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
                <linearGradient
                    id='paint2_linear_50_792'
                    x1='17.9299'
                    y1='-10.0528'
                    x2='17.6717'
                    y2='112.904'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
                <linearGradient
                    id='paint3_linear_50_792'
                    x1='98.5021'
                    y1='-9.88331'
                    x2='98.2438'
                    y2='113.072'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
                <linearGradient
                    id='paint4_linear_50_792'
                    x1='121.108'
                    y1='-9.83576'
                    x2='120.849'
                    y2='113.12'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
                <linearGradient
                    id='paint5_linear_50_792'
                    x1='118.274'
                    y1='-9.84196'
                    x2='118.016'
                    y2='113.115'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0.0051' stopColor='#723D10' />
                    <stop offset='0.0099' stopColor='#8A5D2D' />
                    <stop offset='0.0165' stopColor='#A5814D' />
                    <stop offset='0.024' stopColor='#BEA16B' />
                    <stop offset='0.0322' stopColor='#D2BD83' />
                    <stop offset='0.0415' stopColor='#E3D397' />
                    <stop offset='0.0524' stopColor='#F0E4A6' />
                    <stop offset='0.0659' stopColor='#F8EFB1' />
                    <stop offset='0.0847' stopColor='#FEF6B7' />
                    <stop offset='0.1371' stopColor='#FFF8B9' />
                    <stop offset='0.1484' stopColor='#FFF1A2' />
                    <stop offset='0.1631' stopColor='#FFEA8C' />
                    <stop offset='0.1804' stopColor='#FFE57B' />
                    <stop offset='0.2018' stopColor='#FFE270' />
                    <stop offset='0.2318' stopColor='#FFE069' />
                    <stop offset='0.3152' stopColor='#FFDF67' />
                    <stop offset='0.32' stopColor='#FFE36F' />
                    <stop offset='0.3348' stopColor='#FFEB81' />
                    <stop offset='0.3523' stopColor='#FFF18E' />
                    <stop offset='0.3751' stopColor='#FFF496' />
                    <stop offset='0.4224' stopColor='#FFF598' />
                    <stop offset='0.4936' stopColor='#FFF7AF' />
                    <stop offset='0.5106' stopColor='#FDF0A0' />
                    <stop offset='0.5498' stopColor='#FAE382' />
                    <stop offset='0.5885' stopColor='#F7DA6C' />
                    <stop offset='0.6258' stopColor='#F6D45F' />
                    <stop offset='0.6606' stopColor='#F5D25B' />
                    <stop offset='0.6821' stopColor='#F7DA6F' />
                    <stop offset='0.7259' stopColor='#FCEEA4' />
                    <stop offset='0.7455' stopColor='#FFF8BD' />
                    <stop offset='0.7482' stopColor='#FDF5B7' />
                    <stop offset='0.7715' stopColor='#F1DA89' />
                    <stop offset='0.7948' stopColor='#E6C563' />
                    <stop offset='0.8178' stopColor='#DEB445' />
                    <stop offset='0.8404' stopColor='#D8A830' />
                    <stop offset='0.8624' stopColor='#D4A023' />
                    <stop offset='0.8832' stopColor='#D39E1F' />
                    <stop offset='0.89' stopColor='#D5A225' />
                    <stop offset='0.8992' stopColor='#DAAC36' />
                    <stop offset='0.9097' stopColor='#E3BE53' />
                    <stop offset='0.9212' stopColor='#EFD67A' />
                    <stop offset='0.9334' stopColor='#FEF5AC' />
                    <stop offset='0.934' stopColor='#FFF7AF' />
                    <stop offset='0.9444' stopColor='#FCF3AC' />
                    <stop offset='0.9539' stopColor='#F3E8A3' />
                    <stop offset='0.9631' stopColor='#E3D693' />
                    <stop offset='0.9721' stopColor='#CEBB7E' />
                    <stop offset='0.981' stopColor='#B29962' />
                    <stop offset='0.9898' stopColor='#907040' />
                    <stop offset='0.9983' stopColor='#684018' />
                    <stop offset='1' stopColor='#5F350F' />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default OfficeOfTheYearLogo
